<template>
  <div class="leftBar">
    <v-drawer :direction="'left'" :width="'26%'">
      <div class="animated fadeInLeftBig dx">
        <!--
        <left-card class="lefts" :bg="'border2'">
          <v-title>产业情况</v-title>
          <div class="panelContent">
            <left-top />
          </div>
        </left-card> -->
        <bar-card class="lefts lefts2" :bg="'border2'">
          <v-title>种植分布</v-title>
          <div class="panelContent">
            <!-- <left-mid /> -->
            <left-zzfb />
          </div>
        </bar-card>

        <bar-card class="lefts lefts2" :bg="'border2'">
          <v-title>{{ sjObj.name }}</v-title>
          <div class="panelContent">
            <right-top />
          </div>
        </bar-card>
        <!--
        <bar-card class="lefts lefts3" :bg="'border2'">
          <v-title>企业组成</v-title>
          <div class="panelContent">
            <left-bot />
          </div>
        </bar-card>
        <bar-card class="lefts lefts4" :bg="'border2'">
          <v-title>荔枝名录</v-title>
          <div class="panelContent">
            <pic-list></pic-list>
          </div>
        </bar-card> -->
        <left-card class="lefts lefts2" :bg="'border2'">
          <v-title>茂名荔枝产业历史发展情况</v-title>
          <div class="panelContent">
            <left-top />
          </div>
        </left-card>
        <!-- <map-nav-bar /> -->
      </div>
    </v-drawer>
  </div>
</template>

<script>
import leftTop from "./leftBar/leftTop";
// import leftMid from "./leftBar/leftMid";
// import leftBot from "./leftBar/leftBot";
// import picList from "./leftBar/picList";
import rightTop from "./rightBar/rightTop";
import leftZzfb from "./leftBar/leftZzfb";

export default {
  components: {
    leftTop,
    // leftBot,
    // leftMid,
    // picList
    rightTop,
    leftZzfb,
  },
  data() {
    // const year = new Date().getFullYear();
    return {
      sjObj: {
        // name: "产业分布(" + year + ")",
        name: "产业分布",
      },
    };
  },
};
</script>

<style lang="stylus" scoped>
.dx
  height 100%

.panelContent
  height calc(100% - 43px)
  color #fff

.lefts
  // height calc(83.5% - 8px)
  height calc(30% - 8px)
  margin-bottom 8px

.lefts2
  height calc(33.3% - 8px)
  // height 30%

.lefts3
  height 20%

.lefts4
  height calc(20% - 20px)

.leftBar
  >>>.side
    bottom 8px

@media (min-height 1400px)
  .leftBar
    >>>.side
      width 24% !important

  .panelContent
    // height calc(100% - 43px)
    height calc(100% - .2rem)

@media (max-width 1280px)
  .panelContent
    height calc(100% - 25px)
</style>
